export function createChatLink(_ref) {
  var accountName = _ref.accountName,
    userData = _ref.userData,
    host = _ref.host,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'AllClients' : _ref$location;
  var url = "https://".concat(accountName, ".").concat(host, "/client.php?visit-session-id=&location=").concat(location, "&mode=chat");
  if (userData) {
    var stringifiedUserData = JSON.stringify(userData);
    url += "&provided-visitor=".concat(encodeURIComponent(stringifiedUserData));
  }
  return url;
}